import { RootState } from 'editor/src/store/index';

const getThe3dPreviews = (state: RootState) => state.editorModules.preview.the3dPreview;

export default getThe3dPreviews;
